import { Component } from '@angular/core';
import { LinkComponent } from '../../../components/link/link.component';
import { LanguageSelectorComponent } from '../language-selector/language-selector.component';

@Component({
  selector: 'app-footer',
  imports: [LinkComponent, LanguageSelectorComponent],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css',
})
export class FooterComponent {
  protected currentYear: number;

  constructor() {
    this.currentYear = new Date().getFullYear();
  }
}
